<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!customer">
      <span class="loader"></span>
    </span>
    <div v-if="customer" class="elite-tabs-wrapper">
      <div class="tabs-wrapper">
        <tabs
          fill
          class="flex-column flex-md-row"
          tabNavWrapperClasses="nav-wrapper"
          tabNavClasses="nav elite-tabs"
          :value="currentTab"
          @onTabChanged="tabChanged"
        >
          <tab-pane title="global" id="1" :active="true">
            <span slot="title">
              <i class="fa-regular fa-list"></i>
              {{ $t("COMMON.GLOBAL") }}
            </span>
            <customer-view-global :customer="customer" @customerUpdated="get" />
          </tab-pane>

          <tab-pane title="inspections" id="2" :active="true">
            <span slot="title">
              <i class="fa-regular fa-clipboard-check"></i>
              {{ $t("COMMON.INSPECTIONS") }}
            </span>
            <customer-view-inspections :customer="customer" />
          </tab-pane>

          <tab-pane title="estimations" id="3" :active="true">
            <span slot="title">
              <i class="far fa-usd-circle"></i>
              {{ $t("COMMON.ESTIMATES") }}
            </span>
            <customer-view-estimates :customer="customer" />
          </tab-pane>

          <tab-pane
            title="contacts"
            id="4"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)"
          >
            <span slot="title">
              <i class="fa-regular fa-circle-user"></i>
              {{ $t("COMMON.CONTACTS") }}
            </span>
            <customer-view-contacts :customer="customer" />
          </tab-pane>

          <tab-pane
            title="files"
            id="998"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
          >
            <span slot="title">
              <i class="far fa-file-alt"></i>
              {{ $t("COMMON.FILES") }}
            </span>
            <div class="elite-tabs-wrapper-content">
              <list-file-component :object="customer" />
            </div>
          </tab-pane>

          <tab-pane
            title="logs"
            id="999"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
          >
            <span slot="title">
              <i class="fa fa-history"></i>
              {{ $t("COMMON.LOGS") }}
            </span>
            <customer-view-logs :customer="customer" />
          </tab-pane>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import CustomerViewLogs from "../partials/CustomerViewLogs.vue";
import CustomerViewContacts from "../partials/CustomerViewContacts.vue";
import CustomerViewGlobal from "../partials/CustomerViewGlobal.vue";
import CustomerViewInspections from "../partials/CustomerViewInspections.vue";
import CustomerViewEstimates from "../partials/CustomerViewEstimates.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    CustomerViewGlobal,
    CustomerViewLogs,
    CustomerViewContacts,
    ListFileComponent,
    CustomerViewEstimates,
    CustomerViewInspections,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      customer: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("customers/get", this.customerId);
        this.customer = this.$store.getters["customers/customer"];
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
